import React from 'react';
import StageWithText from 'commonComponents/Stages/StageWithText/StageWithText';
import HowItWorksSection from './HowItWorksSection/HowItWorksSection';
import WhyInvestInClubDealsSection from './WhyInvestInClubDealsSection/WhyInvestInClubDealsSection';
import Strategies from './Strategies/Strategies';
import CurrentOpportunityTile from 'commonComponents/tiles/CurrentOpportunityTile/CurrentOpportunityTile';
import SectionWithBoxes from 'commonComponents/sections/SectionWithBoxes/SectionWithBoxes';
import Consultants from 'commonComponents/Consultants/Consultants';

import styles from '../pages.module.scss';

import { ClubDealsLogo, currentOpportunitiesCardImages } from './images';

/*eslint max-lines-per-function: ["error", 200]*/
const ClubDealsPage = ({
  banner, howItWorks, whyInvestInClubDeals, experts, strategies, currentOpportunities,
  requestInfoLink
}) => {

  const bannerProps = {
    ...banner,
    logo: ClubDealsLogo,
    pageName: 'clubDeals',
    button: {
      label: banner.button,
      link: requestInfoLink
    }
  };

  const currentOpportunitiesProps = {
    ...currentOpportunities,
    button: null
  };

  const { tiles } = currentOpportunities;

  currentOpportunitiesProps.boxes = Object.keys(tiles)
    .map((opportunity, ind) => {
      return {
        opportunity,
        ...tiles[opportunity],
        photo: currentOpportunitiesCardImages[ind],
        button: {
          label: banner.button,
          link: requestInfoLink
        }
      };
    });

  currentOpportunitiesProps.boxRender = (box) => {
    return (
      <CurrentOpportunityTile
        { ...box }
        key={ box.opportunity }
      />
    );
  };

  const consultants = [...experts.team];
  consultants.forEach(person => person.isPrimary = true);

  const consultantsProps = {
    ...experts,
    consultants,
    link: requestInfoLink
  };

  return (
    <div className={ styles.Page }>
      <StageWithText { ...bannerProps } />
      <HowItWorksSection { ...howItWorks } link={ requestInfoLink } />
      <WhyInvestInClubDealsSection { ...whyInvestInClubDeals } />
      <Consultants { ...consultantsProps } />
      <section></section>
      <Strategies { ...strategies } />
      <SectionWithBoxes
        { ...currentOpportunitiesProps }
        anchor='current-opportunuties'
      />
    </div>
  );
};

export default ClubDealsPage;
